export const MENU_GROUPS = [
    {id: 'operations', label: 'Operations'},
    {id: 'training', label: 'Training'},
    {id: 'resources', label: 'Resources'},
    {id: 'scheduling', label: 'Scheduling'},
    {id: 'tasks', label: 'Tasks'},
    {id: 'standards', label: 'Standards'},
    {id: 'files', label: 'Files'},
    {id: 'administration', label: 'Administration'}
];

export const DEFAULT_SHORTCUTS = ['/', '/apparatus', '/incidents', '/training'];

export const GROUP_MAP = {
    '/': 'operations',
    '/apparatus': 'operations',
    '/stations': 'operations',
    '/incidents': 'operations',
    '/matrix/qualification': 'training',
    '/training': 'training',
    '/matrix/training': 'training',
    '/public-education': 'training',
    '/gear': 'resources',
    '/preplans': 'resources',
    '/calendar': 'scheduling',
    '/regional-training': 'scheduling',
    '/dutyshifts': 'scheduling',
    '/payroll': 'scheduling',
    '/admin-hours': 'scheduling',
    '/workzoom': 'scheduling',
    '/tasks': 'tasks',
    '/training-standards': 'standards',
    '/quizzes/fr': 'standards',
    '/settings': 'administration',
    '/help': 'administration',
    '/users': 'administration',
    '/history': 'administration'
};
